import { render } from "./ClassEffdtView.vue?vue&type=template&id=de56369e"
import script from "./ClassEffdtView.vue?vue&type=script&lang=js"
export * from "./ClassEffdtView.vue?vue&type=script&lang=js"

import exportComponent from "/srv/git/index-webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__